// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__325Fc","addWidgetButton":"Header_addWidgetButton__3-oNc","dashboardTabs":"Header_dashboardTabs__Z3Ex1","active":"Header_active___wEyK"};